import type { CoachNoteDto, CoachNoteInputDto } from "@/modules/sessions/gateway/sessionBlockDto"
import type { NoteType } from "@/modules/sessions/sessionDetails/blocks/noteBlock/noteTypes"
import type { CoachNoteFormikType } from "@/modules/sessions/sessionForm/blocks/noteBlock/noteFormikTypes"

export class SessionBlockCoachNoteEntity {
  id: string
  orderIndex: number
  note: string
  noteType: NoteType
  durationInMin: number | null

  private constructor(sessionBlockCoachNote: SessionBlockCoachNoteEntity) {
    this.id = sessionBlockCoachNote.id
    this.orderIndex = sessionBlockCoachNote.orderIndex
    this.note = sessionBlockCoachNote.note
    this.noteType = sessionBlockCoachNote.noteType
    this.durationInMin = sessionBlockCoachNote.durationInMin
  }

  static fromDto(dto: CoachNoteDto): SessionBlockCoachNoteEntity {
    return new SessionBlockCoachNoteEntity({
      id: dto.id,
      orderIndex: dto.orderIndex,
      note: dto.note,
      noteType: dto.noteType,
      durationInMin: dto.durationInMin,
    })
  }

  static fromEntityToInputDto(entity: SessionBlockCoachNoteEntity): CoachNoteInputDto {
    return {
      id: entity.id,
      note: entity.note,
      noteType: entity.noteType,
      durationInMin: entity.durationInMin,
      orderIndex: entity.orderIndex,
    }
  }

  static fromEntityToFormik(entity: SessionBlockCoachNoteEntity): CoachNoteFormikType {
    return {
      id: entity.id,
      note: entity.note,
      noteType: entity.noteType,
      durationInMin: entity.durationInMin,
    }
  }

  static fromFormikToInputDto(formik: CoachNoteFormikType, orderIndex: number): CoachNoteInputDto {
    if (!formik.note) throw new Error("Note is required") // This should never happen because the formik is validated
    if (!formik.noteType) throw new Error("Note type is required") // This should never happen because the formik is validated
    return {
      id: formik.id,
      note: formik.note,
      noteType: formik.noteType,
      durationInMin: formik.durationInMin,
      orderIndex: orderIndex,
    }
  }
}
